import { Helpers } from '../utilities/helpers';
import { MotorService } from '../services/motorService';
import { removeHomeContentFromQuote } from '../services/buildingAndContentsService';
import Alert from '../components/forms/Alert';

const basketHelpers = {
  removeVehicleFromQuote: async (registration, vehicleId) => {
    const basketStr = await Helpers.getInStorage('allProductsInsuranceCart')
    const basketArray = JSON.parse(basketStr)
    if (basketArray) {
      const res = await MotorService.removeVehicleFromQuote(vehicleId)
      if (res && res.success) {
        const filteredBasket = basketArray.filter((item) => item.registration !== registration)
        await Helpers.setInStorage('allProductsInsuranceCart', JSON.stringify(filteredBasket))
        return filteredBasket
      } else {
        Alert.alert('Could not remove vehicle from quote', res.error.message)
      }
    }
  },

  removeHomeContentFromQuote: async (ObjectNo) => {
    const basketStr = await Helpers.getInStorage('allProductsInsuranceCart')
    const basketArray = JSON.parse(basketStr)
    const userId = await Helpers.getAuthUserId()
    if (basketArray && userId && ObjectNo) {
      const res = await removeHomeContentFromQuote({user_id: userId, objectNo: ObjectNo})
      if (res && res.success) {
        const filteredBasket = basketArray.filter((item) => item.iwyze_object_no !== ObjectNo)
        await Helpers.setInStorage('allProductsInsuranceCart', JSON.stringify(filteredBasket))
        return filteredBasket
      } else {
        const errorMessage = res?.error?.message || 'An unknown error occurred while removing content from the quote'
        Alert.alert('Could not remove home content from quote', errorMessage)
      }
    }
  }
}

export { basketHelpers }